export const api = `${window.location.protocol}//${window.location.hostname}/cfc/api/`;

export const ga4Config = {
	id: process.env.REACT_APP_GA4_ID,
};

export const gtmConfig = {
	containerId: process.env.REACT_APP_GTM_ID,
};

export const googleApiKey = process.env.REACT_APP_GOOGLE_API_KEY;

// The live ordering demo on the Trash Joe's platform (no card, nothing charged).
export const demoUrl = 'https://go.trashjoes.com/trash-joes/app/select-services';
